import React from 'react'
import { SvgIcon } from '@mui/material'

// Directly import SVGs as URLs
import IncompleteIcon from 'components/assets/icon_incomplete.svg'
import PaidIcon from 'components/assets/icon_paid.svg'
import PriceCompleteIcon from 'components/assets/icon_price_complete.svg'
import ScaleCompleteIcon from 'components/assets/icon_scale_complete.svg'
import PropTypes from 'prop-types'

/*
 Makes it so that we can import SVGs the same way in CRA or Vite.
 Vite does not support importing SVGs as React components without a plugin and a custom import syntax.
 We get around it by importing the SVG as a URL and wrapping it with the SvgIcon component ourselves.
*/
const IconFromUrl = ({ url, viewBox, fontSize }) => (
  <SvgIcon viewBox={viewBox} fontSize={fontSize}>
    <image href={url} width="100%" height="100%" />
  </SvgIcon>
)

IconFromUrl.propTypes = {
  url: PropTypes.string.isRequired,
  viewBox: PropTypes.string.isRequired,
  fontSize: PropTypes.string.isRequired,
}

export const Incomplete = () => <IconFromUrl url={IncompleteIcon} viewBox="0 0 32 32" fontSize="small" />

export const Paid = () => <IconFromUrl url={PaidIcon} viewBox="0 0 18 18" fontSize="small" />

export const PriceComplete = () => <IconFromUrl url={PriceCompleteIcon} viewBox="0 0 15 16" fontSize="small" />

export const ScaleComplete = () => <IconFromUrl url={ScaleCompleteIcon} viewBox="0 0 18 18" fontSize="small" />
